import script from "./palaFrontalIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./palaFrontalIcon.vue?vue&type=script&setup=true&lang=js"

import "./palaFrontalIcon.vue?vue&type=style&index=0&id=b828e8d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b828e8d0"]])

export default __exports__